import { AdvisorProfileResponse } from "./advisorProfile.types";
import { PageResponse } from "./medicineSearch.types";

// Association portal, slice 5: the advisor roster of one association,
// verified against apoteka-back @ bd35a05f (AssociationController
// `GET/POST /association/{id}/advisor`, `DELETE /association/{id}/advisor/{advisorProfileId}`,
// AdvisorProfileService.searchAdvisors, the shared PageResponse).

/**
 * Query of `GET /association/{id}/advisor`. All optional: `page` is 0-based
 * (default 0), `numOfReturns` defaults to 20, `onlyAvailable` to false, and
 * an absent `sort` means best-rated first with an id tie-break.
 */
export interface AssociationAdvisorsParams {
  /** Matched against the advisor's name. */
  search?: string;
  onlyAvailable?: boolean;
  page?: number;
  numOfReturns?: number;
  /** `field:asc` / `field:desc`. */
  sort?: string;
}

/**
 * The backend's generic `PageResponse`: `pageNum` echoes the requested
 * 0-based page, so more rows exist while `pageNum + 1 < totalNumOfPages`.
 */
export type AssociationAdvisorsPage = PageResponse<AdvisorProfileResponse>;

export const ROSTER_PAGE_SIZE = 20;
